import { defineMessages } from 'react-intl';

export default defineMessages({
    policyDetailsTitle: {
        id: 'policychange.wizard.step.policyChange.Policy Details',
        defaultMessage: 'Policy Details',
    },
    fieldLabel: {
        id: 'twia.policychange.ho.views.policy-info.policyChange.Primary Named Insured',
        defaultMessage: 'Primary Named Insured',
    },
    fieldLabelCompany: {
        id: 'twia.policychange.ho.views.policy-info.policyChange.Name',
        defaultMessage: 'Name',
    },
    saveModalTitle: {
        id: 'twia.policychange.ho.views.policy-info.policyChange.Please save or cancel',
        defaultMessage: 'Please save or cancel',
    },
    saveModalText: {
        id: 'twia.policychange.ho.views.policy-info.policyChange.Please save or cancel changes before continuing',
        defaultMessage: 'Please save or cancel changes before continuing',
    },
    renewalScheduledMessage: {
        id: 'twia.policychange.ho.views.policy-info.renewal Scheduled Message',
        defaultMessage: 'This policy has a renewal scheduled to take effect in the future. To apply this change to the future renewal term you must complete a separate policy change.',
    }
})